import { api } from '@/core/api/'

const apiUrl = 'api/progress'

export default {
  getAcademicYears(stipulationType) {
    return api.get(`${apiUrl}/availableacademicyears/${stipulationType}`)
  },
  getDetail(properties) {
    return api.get(`${apiUrl}/detail`, {
        params: {
            ...properties
        }
    });
  },
  getIpHistory(stipulationType, academicYearId, ip) {
    return api.get(`${apiUrl}/iphistory/${stipulationType}/${academicYearId}/${ip}`)
  },
  updateIp(stipulationType, academicYearId, isUpdate) {
    return api.put(`${apiUrl}/updateip/${stipulationType}/${academicYearId}/${isUpdate}`)
  },
  closeIp(stipulationType, summaryId) {
    return api.post(`${apiUrl}/closeip/${stipulationType}/${summaryId}`)
  },
  isLastIpClosed(stipulationType, academicYearId) {
    return api.get(`${apiUrl}/islastipclosed/${stipulationType}/${academicYearId}`)
  },
  queueIpAttachment(stipulationType) {
    return api.post(`${apiUrl}/queueipattachment/${stipulationType}`)
  },
  queueHearingCase(stipulationType) {
    return api.post(`${apiUrl}/queuehearingcase/${stipulationType}`)
  },
  queueIpReport(filters) {
    return api.post(`${apiUrl}/queueipreport`, filters)
  },
  cancelQueuedReport(stipulationType, executionLogId) {
    return api.post(`${apiUrl}/cancelqueuedreport/${stipulationType}/${executionLogId}`)
  },
  downloadQueuedReport(stipulationType, executionLogId) {
    return api.get(`${apiUrl}/downloadqueuedreport/${stipulationType}/${executionLogId}`)
  },
  downloadIpStipulation(filters) {
    return api.get(`${apiUrl}/downloadipstipulation`, {
      params: {
          ...filters
      }
    });
  },
  downloadAttachment(stipulationType) {
    return api.get(`${apiUrl}/downloadattachment/${stipulationType}`)
  },
  generateStipulation15Attachments(filters) {
    return api.get(`${apiUrl}/generatestipulation15attachments`, {
      params: {
          ...filters
      }
    });
  }
}
